import { Button, ButtonProps, LinearProgress, Stack } from '@mui/material'
import { ReactNode } from 'react'

interface Props extends ButtonProps {
  isLoading?: boolean
  showLoading?: boolean
  children?: ReactNode
}

const AsyncActionButton = ({ isLoading, showLoading, children, ...otherProps }: Props) => {
  return (
    <Button fullWidth type="button" {...otherProps}>
      <Stack>
        {isLoading && showLoading && <LinearProgress />}
        {children}
      </Stack>
    </Button>
  )
}

export default AsyncActionButton
